export const NFTSTUDIOS_URI = "https://nftstudios.io/";
export const IMAGE_FORMAT = ["image/png", "image/jpeg"];
export const VIDEO_FORMAT = "video/mp4";
export const VIDEO_MAX = 52428800; //50MB
export const IMAGE_MAX = 10485760; //10MB
